/* eslint-disable */
import React, { useState } from "react";
import { useGetOrg } from "api/organizations/getOrg";
import { useGetScopedUsersList } from "api/users/getScopedUsersList";
import MainHeading from "components/MainHeading";
import NotFound from "components/NotFound";
import { useUser } from "hooks/useUser";

import { useQueryClient } from "@tanstack/react-query";
import { PermissionButton } from "api/permission/buttonpermission";
import PageSkeleton from "features/admin-settings/components/PageSkeleton";
import { Flex, TextInput, Group, Button } from "@mantine/core";
import AddOrgMembersModal from "features/admin-settings/components/AddOrgMembers";
import OrgMembersTable from "features/admin-settings/components/OrgMembersTable";

export function AllEmployees() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // ✅ Email search states
  const [email, setEmail] = useState("");
  const [searchEmail, setSearchEmail] = useState<string | undefined>(undefined);

  // Fetch organization info (for org details)
  const {
    data: org,
    isLoading: orgLoading,
    isError: orgError,
  } = useGetOrg(user.org?._id);

  // Fetch members using scoped-list API
  const {
    data: membersResponse,
    isLoading: membersLoading,
    isError: membersError,
  } = useGetScopedUsersList(page, limit, searchEmail);

  const [opened, setOpened] = useState(false);

  const handleClose = async () => {
    setOpened(false);
    await queryClient.invalidateQueries(["scoped-users"]);
  };

  const handleSearch = () => {
    setPage(1); // ✅ reset pagination on search
    setSearchEmail(email.trim() || undefined);
  };

  const handleClear = () => {
    setEmail("");
    setSearchEmail(undefined);
    setPage(1);
  };

  if (user.role === "member") {
    return <NotFound />;
  }

  if (orgLoading || membersLoading) {
    return <PageSkeleton />;
  }

  if (orgError || !org || membersError || !membersResponse) {
    return <NotFound />;
  }

  return (
    <>
      <MainHeading title="All Employees" />

      <div
        style={{
          backgroundColor: "white",
          padding: "6px 16px 20px 20px",
          borderRadius: "5px",
        }}
      >
        <Flex
          justify="space-between"
          align="center"
          mt="md"
          wrap="wrap"
          gap="md"
        >
          <h2 style={{ margin: 0, fontSize: "18px" }}>
            All Employee
          </h2>

          <Group>
            {/* ✅ Search Box */}
            <TextInput
              placeholder="Search by email"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              style={{
                maxWidth: 250,
                height: "42px",
                minHeight: "42px",
              }}
              styles={{
                input: {
                  height: "42px",
                  minHeight: "42px",
                },
              }}
            />
            <Button onClick={handleSearch} variant="outline">
              Search
            </Button>
            {searchEmail && (
              <Button onClick={handleClear} variant="subtle" color="gray">
                Clear
              </Button>
            )}

            <PermissionButton
              permission="organization_management.memberAdd"
              onClick={() => setOpened(true)}
            >
              Add Members
            </PermissionButton>
          </Group>
        </Flex>

        <div style={{ backgroundColor: "white" }}>
          <OrgMembersTable
            members={membersResponse.data}
            user={user}
            orgId={org._id}
            pagination={membersResponse.pagination}
            onPageChange={setPage}
            currentPage={page}
          />
        </div>
      </div>

      <AddOrgMembersModal opened={opened} onClose={handleClose} org={org} />
    </>
  );
}
